import * as permissionUtils from './permissions'

const getters = {
    loggedIn: (state) => !!state.accessToken,
    hasPermission: (state) => (permission) => state.permissions.includes(permission),
    userRoles: (state) => state.roles,

    // Dynamically map all permission functions
  ...Object.fromEntries(
    Object.entries(permissionUtils).map(([key, fn]) => [
      key, state => fn.bind(null, state.permissions),
    ])
  ),
}

export default getters